import { render, staticRenderFns } from "./AppOverlay.vue?vue&type=template&id=58218fed&scoped=true"
import script from "./AppOverlay.vue?vue&type=script&lang=js"
export * from "./AppOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_webpack@4_6rzqd64q6y3fbidgrbnvwpeysm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58218fed",
  null
  
)

export default component.exports